var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, QueryList } from '@angular/core';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { InfoStore } from '../../../stores/hub.calendar.store';
import { InfoModalData, ShowInfoModalActions } from './show.info.modal.provider';
var ShowInfoModalComponent = /** @class */ (function (_super) {
    __extends(ShowInfoModalComponent, _super);
    function ShowInfoModalComponent(dialogRef, actions, imageService, infoStore, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.imageService = imageService;
        _this.infoStore = infoStore;
        _this.showCopy = false;
        _this.title = data.title;
        _this.icons = data.icons;
        _this.info = data.info;
        _this.plainText = data.plainText;
        _this.showCopy = data.showCopy;
        _this.infoStore.infoCommand.takeUntil(_this.isDestroyed).subscribe(function (info) {
            _this.info.push(info);
            setTimeout(function () {
                _this.content.toArray().forEach(function (x, index) {
                    x.nativeElement.innerHTML = _this.info[index];
                });
            });
        });
        return _this;
    }
    ShowInfoModalComponent.prototype.append = function (text) {
        this.div.nativeElement.innerHTML += "<div>" + text + "</div>";
    };
    ShowInfoModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    ShowInfoModalComponent.prototype.copy = function () {
        this.copyToClip(this.plainText || this.info[0]);
    };
    ShowInfoModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    Object.defineProperty(ShowInfoModalComponent.prototype, "code", {
        get: function () {
            if (!this.plainText)
                return '';
            return "<pre style=\"margin:0\"><code>" + this.plainText.replaceAll('<', '&lt;').replaceAll('>', '&gt;') + "</code></pre>";
        },
        enumerable: true,
        configurable: true
    });
    ShowInfoModalComponent.prototype.copyToClip = function (content) {
        var aux = document.createElement('input');
        aux.setAttribute('value', content);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand('copy');
        document.body.removeChild(aux);
        alert('Link is copied to the clipboard');
    };
    return ShowInfoModalComponent;
}(BaseComponent));
export { ShowInfoModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.info.modal/show.info.modal.component.ts.pre-build-optimizer.js